<!--
    The folder/topic analytics dashboard, scoped to this agent. The narrowing is applied by
    AgentAnalyticsFilterResolver before this view is created - see the note there.
-->
<agpr-monitoring-analytics-dashboard
    [showHeader]="false"
></agpr-monitoring-analytics-dashboard>
